
<router-outlet></router-outlet>

<div *ngIf="loading || systemLoading" class="loading-wrapper animated fadeIn">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
    
    <p class="mt-6 text-center text-slate-800">{{loading || systemLoading}}</p>
</div>
<!-- zoom button -->
<button *ngIf="showScaleButton" class="toggle-scale-button" mat-icon-button (click)="toggleScale()" aria-label="Zoom">
  <belender-icon class="toggle-scale-icon" [name]="isScaled ? 'zoom_out' : 'zoom_in'"></belender-icon>
</button>